/**
 * Модель сохранений профиля игрока (persisted state).
 * Не подключено к сценам — только типы и хелперы.
 */

import type { Difficulty, PackId, PuzzleId } from '../data/types';

/** Источник текущего пазла (обучение / daily / pack / пересбор из коллекции). */
export type ActivePuzzleSource = 'tutorial' | 'daily' | 'pack' | 'collection';

/** Статус прохождения обучения: не проходил / на шаге 2 (шаг 1 сделан) / пропустил / прошёл. */
export type TutorialStatus = 'none' | 'step2' | 'skipped' | 'completed';

export interface ActivePuzzle {
  puzzleId: PuzzleId;
  source: ActivePuzzleSource;
  difficulty: Difficulty;
  startedAt: number;
}

export interface ProfileState {
  version: number;
  coins: number;
  noAds: boolean;
  purchasedPacks: Record<PackId, true>;
  rewardedUnlocked: Record<PuzzleId, true>;
  collectedPuzzleImages: Record<string, true>;
  /** Время добавления в коллекцию (timestamp), для сортировки «сначала новые». */
  collectedAt?: Record<string, number>;
  collectedCount: number;
  activePuzzle?: ActivePuzzle;
  /** Статус обучения: отсутствует/none → показывать туториал при запуске. */
  tutorialStatus?: TutorialStatus;
  daily: {
    lastSeenKey?: string;
    collectedKey?: string;
  };
}

export function createDefaultProfileState(): ProfileState {
  return {
    version: 1,
    coins: 0,
    noAds: false,
    purchasedPacks: {},
    rewardedUnlocked: {},
    collectedPuzzleImages: {},
    collectedCount: 0,
    tutorialStatus: 'none',
    daily: {},
  };
}

/**
 * Вычисляет количество уникально собранных картинок из collectedPuzzleImages.
 * Можно использовать для проверки/синхронизации с state.collectedCount.
 */
export function deriveCollectedCount(state: ProfileState): number {
  return Object.keys(state.collectedPuzzleImages).length;
}
